module.exports = __webpack_public_path__ + "img/img.a0d98d02.svg";